import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Nog geen producten.',
  fields: {
    number: '#',
    image: 'Afbeelding',
    name: 'Naam',
    external_id: '{{integration}} ref',
    price: 'Prijs',
    prices: 'Prijzen',
    description: 'Omschrijving',
    tags: 'Tags',
    status: 'Status',
    product_type: 'Type',
    statuses: {
      good: 'Goed',
      bad: 'Slecht',
      medium: 'Gemiddeld',
    },
    product_types: {
      packaged: 'Verpakt',
      prepared: 'Bereid',
    },
  },
  labels: {
    visible: 'Zichtbaar in menu',
    hidden: 'Alles verborgen',
  },
  order_method_prices: {
    base: 'Basis',
    [ORDER_METHODS.pickup]: 'Afhalen',
    [ORDER_METHODS.delivery]: 'Bezorging',
    [ORDER_METHODS.room_service]: 'Kamer-/tafelservice',
  },
  buttons: {
    delete_products_one: 'Product verwijderen',
    delete_products_other: 'Producten verwijderen',
    add_product: '+ Product toevoegen',
    show_products: 'Producten tonen',
    hide_products: 'Producten verbergen',
    add: 'Toevoegen',
    edit: 'Bewerken',
    duplicate: 'Dupliceren',
    history: 'Geschiedenis',
    delete: 'Verwijderen',
    delete_all: 'Alles verwijderen',
  },
  toasts: {
    failed_to_duplicate_category: 'Categorie dupliceren mislukt',
    category_duplicated_successfully: 'Categorie succesvol gedupliceerd',
    failed_to_duplicate_product: 'Product dupliceren mislukt',
    product_duplicated_successfully: 'Product succesvol gedupliceerd',
    failed_to_delete_variant: 'Variant verwijderen mislukt',
    variant_got_deleted: 'Variant verwijderd',
    something_went_wrong: 'Er is iets misgegaan',
  },
};
